import client from '../httpClient';

const responseResisterMediumApi = (params) => {
  return client.post('/response-types/', JSON.stringify(params));
};

export default responseResisterMediumApi;
